export const CouriersCategoriesColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Название',
        key: 'name',
    },
]
